import React from 'react';
import { TransformCta } from '../TransformCta';
import { AUTHOR_URL } from '../../data/offer';
export function Author() {
  return <section className="bg-ink py-16 sm:py-24" aria-labelledby="author-title" data-id="element-78" data-mp="1htc6d8h2jhh9">
      <div className="mx-auto max-w-5xl px-5" data-id="element-79" data-mp="1whqenyx97y57">
        <div className="grid items-center gap-8 lg:grid-cols-[380px_1fr] lg:gap-14" data-id="element-80" data-mp="1wii38psfovlz">
          <figure className="relative mx-auto w-full max-w-sm" data-id="element-81" data-mp="1rnvn69beqevk">
            <img src={AUTHOR_URL} alt="Jason Mitchell, author of HVAC Electrical Troubleshooting Blueprint" className="aspect-[4/5] w-full rounded-3xl object-cover object-top ring-1 ring-line" data-id="element-82" data-mp="25gbsjgrs6ozn" />
            <figcaption className="absolute inset-x-4 bottom-4 rounded-2xl bg-ink/90 px-4 py-3 backdrop-blur" data-id="element-83" data-mp="2fd6pvwcbijcc">
              <p className="font-display text-2xl font-extrabold uppercase text-white" data-id="element-84" data-mp="l18je25e81k5">Jason Mitchell</p>
              <p className="text-sm text-mist" data-id="element-85" data-mp="g2ovvxb5ihpo">Author of HVAC Electrical Troubleshooting Blueprint™</p>
            </figcaption>
          </figure>

          <div data-id="element-86" data-mp="3gfxlphqug84q">
            <p className="font-display text-lg font-bold uppercase tracking-[0.06em] text-volt" data-id="element-87" data-mp="3gc9pubxxf9mu">
              A practical resource for structured HVAC electrical troubleshooting
            </p>
            <h2 id="author-title" className="mt-2 font-display text-[42px] font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-88" data-mp="3pdpxibxcwxnd">
              Created by Jason Mitchell
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-mist" data-id="element-89" data-mp="2z6oyvv2ccot">
              This professional resource is organized around a practical principle:
            </p>
            <blockquote className="mt-4 border-l-4 border-amber pl-5 text-xl font-semibold leading-snug text-white" data-id="element-90" data-mp="c17k9n6qkonu">
              Electrical troubleshooting should follow a documented process that connects observations, circuit
              information, appropriate verification, and evidence-based conclusions.
            </blockquote>
            <div className="mt-5 space-y-3 text-[17px] leading-relaxed text-mist" data-id="element-91" data-mp="2isotl3wc80tr">
              <p data-id="element-92" data-mp="3m21ii0pzpq2q">The HVAC ELECTRICAL FAULT PATHWAY™ brings those elements together into one structured workflow.</p>
              <p data-id="element-93" data-mp="3h4hyslaiwl3e">
                Rather than presenting disconnected technical information, the blueprint focuses on reusable tools that
                support professional troubleshooting organization.
              </p>
              <p className="text-white" data-id="element-94" data-mp="8uq3r5l0ss4e">
                <strong data-id="element-95" data-mp="8torixs9pzl3">The objective is simple:</strong> help qualified HVAC professionals approach electrical fault
                investigations with a clearer process and more consistent documentation.
              </p>
            </div>
          </div>
        </div>

        <TransformCta label="Get Jason’s complete workflow" data-id="element-96" data-mp="dl6hyrwo0hrt" />
      </div>
    </section>;
}